export default function numbers() {
    if (document.querySelector(".numbers")) {
        document.addEventListener("DOMContentLoaded", () => {
            const counters = document.querySelectorAll(".counter");

            const animateCounter = (counter) => {
                const target = +counter.getAttribute("data-target");
                const suffix = counter.getAttribute("data-suffix") || "";
                const duration = 2000;
                const increment = target / (duration / 16);

                let current = 0;

                const updateCounter = () => {
                    current += increment;

                    if (current < target) {
                        counter.innerText = "+" + Math.floor(current) + " " + suffix;
                        requestAnimationFrame(updateCounter);
                    } else {
                        counter.innerText = "+" + target + " " + suffix;
                    }
                };

                updateCounter();
            };

            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        animateCounter(entry.target);
                        observer.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.5 });

            counters.forEach(counter => observer.observe(counter));
        });
    }
}